// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import productReducer from './slices/productSlice';
import appointmentReducer from './slices/appointmentSlice';
import clientReducer from './slices/clientSlice';
import membershipReducer from './slices/membershipSlice';
import dashboardReducer from './slices/dashboardSlice';
import salesAnalyticsReducer from './slices/salesAnalyticsSlice';
import billReducer from './slices/billSlice';
import allBillingReducer from "./slices/AllBillingSlice"
import serviceReducer from './slices/servicesSlice';
import expenseReducer from './slices/expenseSlice';
import couponReducer from './slices/couponSlice';
import staffReducer from './slices/staffSlice';
import notificationReducer from './slices/notificationSlice';

const store = configureStore({
  reducer: {
    product: productReducer,
    appointments: appointmentReducer,
    clients: clientReducer,
    memberships: membershipReducer,
    dashboard: dashboardReducer,
    salesAnalytics: salesAnalyticsReducer,
    bill: billReducer,
    allBilling: allBillingReducer,
    service: serviceReducer,
    expenses: expenseReducer,
    coupons: couponReducer,
    staffs: staffReducer,
    notifications: notificationReducer,
  },
});

export default store;